import Navbar from './Navbar';
import Hero from './Hero';
import CoreServices from './CoreServices';
import TechCapabilities from './TechCapabilities';
import SmartCity from './SmartCity';
import CaseStudies from './CaseStudies';
import Approach from './Approach';
import IntegrationCapabilities from './IntegrationCapabilities';
import ManagedServices from './ManagedService';
import Form from './Form';
import Footer from './Footer';
import { Helmet } from 'react-helmet';
// import Meta from './Meta';

const Home = () => {
    return (
        <>
          <Helmet>
              <title>Kaizek - Engineering the future of Connected Devices</title>
              <meta name="Kaizek - EMBEDDED SYSTEMS & IoT EXPERTS"
              keywords="ideation, strategy, product, ai, machine learning, data science"
              content="Specializing in custom firmware, embedded software development, and IoT solutions." />
          </Helmet>
          {/* <Meta
              title="Kaizek - Engineering the future of Connected Devices"
              description="Specializing in custom firmware, embedded software development, and IoT solutions."
              keywords="ideation, strategy, product, ai, machine learning, data science"
          /> */}
          <Navbar />
          
          <section id='home'>
            <Hero/>
          </section>
    
          <section id='services'>
            <CoreServices/>
          </section>
    
          <section  id='capabilities'>
            <TechCapabilities/>
          </section>
    
          <section id='smartcity'>
            <SmartCity/>
          </section>
    
          <section id='casestudies'>
            <CaseStudies/>
          </section>
    
          <Approach/>
    
          <section id='integration'>
            <IntegrationCapabilities/>
          </section>
          <ManagedServices/>
    
          <section id='form'>
            <Form/>
          </section>
    
          <section id='contact'>
            <Footer/>
          </section>
        
        </>
    )
}

export default Home